import { combineReducers } from 'redux';
import base64 from 'base-64';

import resolver from '../resolvers/event';

import byId, * as eventsById from './byId';
import byList, * as eventsByList from './byList';
import byPage, * as eventsByPage from './byPage';
import bySelection, * as eventSelected from './bySelection';
import byHover, * as eventHovered from './byHover';

const objects = ['EVENT', 'EVENTS'];

/**
 * Reducers for all state relating to events.
 * Events are stored as full objects within the byId reducer.
 * The byList reducer holds list representations used within the app, e.g. list of search results,
 * these contain a flat array of IDs concerned and present state of the query.
 * The selected reducer holds the ID and query state of the current selected organiser.
 */
const events = combineReducers({
  byId: byId(...objects),
  byList: byList(objects[1]),
  byPage: byPage(objects[1]),
  selected: bySelection(objects[0]),
  hovered: byHover(objects[0])
});

export default events;

// Get an event by ID
export const getEvent = (state, id) => resolver(eventsById.getById(state.byId, id));

// Get all IDs within a list, map to full objects from hash table
export const getList = (state, query) =>
  eventsByList.getIds(state.byList[base64.encode(JSON.stringify(query))])
    .map(id => getEvent(state, id));

export const getPage = (state, query, page) =>
  eventsByPage.getPages(state.byPage[base64.encode(JSON.stringify(query))])[page].map(id => getEvent(state, id));

export const getCurrentPage = (state, query) => {
  const byPage = state.byPage[base64.encode(JSON.stringify(query))];
  const currentPage = eventsByPage.getPages(byPage)[eventsByPage.getCurrentPage(byPage)] || [];
  return currentPage.map(id => getEvent(state, id));
};

// Return the number of events in a list
export const getListCount = (state, query) =>
  eventsByList.getIds(state.byList[base64.encode(JSON.stringify(query))]).length;

// Get the details of an event list
export const getListDetails = (state, query) =>
  eventsByList.getDetails(state.byList[base64.encode(JSON.stringify(query))]);

// Get the error state of a list request
export const getListError = (state, query) =>
  eventsByList.getError(state.byList[base64.encode(JSON.stringify(query))]);

// Get the fetched state of a list
export const getListFetched = (state, query) =>
  eventsByList.getFetched(state.byList[base64.encode(JSON.stringify(query))]);

// Get the fetching state of a list request
export const getListFetching = (state, query) =>
  eventsByList.getFetching(state.byList[base64.encode(JSON.stringify(query))]);

// Get the current page number a list
export const getListPage = (state, query) =>
  eventsByList.getPage(state.byList[base64.encode(JSON.stringify(query))]);

// Return the number of events found on the server for a list
export const getListTotal = (state, query) =>
  eventsByList.getTotal(state.byList[base64.encode(JSON.stringify(query))]);

// Return the number of events found on the server for a list, formatted as string
export const getListTotalFormatted = (state, query) =>
  eventsByList.getTotalFormatted(state.byList[base64.encode(JSON.stringify(query))]); // eslint-disable-line max-len

// Get the ID of selected event
export const getSelectedId = state => eventSelected.getId(state.selected);

// Get the error state of selected event request
export const getSelectedError = state => eventSelected.getError(state.selected);

// Get the fetching state of selected event request
export const getSelectedFetching = state => eventSelected.getFetching(state.selected);

export const checkPageExists = (state, query, page) => eventsByPage.checkPageExists(state.byPage[base64.encode(JSON.stringify(query))], page);

export const getCurrentPageNumber = (state, query) => eventsByPage.getCurrentPage(state.byPage[base64.encode(JSON.stringify(query))]);

export const getPages = (state, query) => eventsByPage.getPages(state.byPage[base64.encode(JSON.stringify(query))]);

// Get id of currently hovered event
export const getHovered = state => eventHovered.getHovered(state.hovered);



// WEBPACK FOOTER //
// ./app/src/state/reducers/events.js